module.exports = __webpack_public_path__ + "static/media/dws_pencil.37ffdd6d.png";